import { miloAlert } from './AlertDialog';
var GlobalManager = {
  loginManager: null,
  customizeUnLogin: false,
  unLoginCallback: function unLoginCallback() {
    if (GlobalManager.loginManager) {
      GlobalManager.loginManager.logout({
        callback: function callback() {
          miloAlert({
            message: '您尚未登录或登录态已失效'
          });
        }
      });
    } else {
      miloAlert({
        message: '您尚未登录或登录态已失效'
      });
    }
  }
};
export default GlobalManager;
export var setUnLoginCallback = function setUnLoginCallback(_callback) {
  GlobalManager.customizeUnLogin = true;

  GlobalManager.unLoginCallback = function (err) {
    if (GlobalManager.loginManager) {
      GlobalManager.loginManager.logout({
        callback: function callback() {
          if (_callback) {
            _callback(err);
          } else {
            miloAlert({
              message: '您尚未登录或登录态已失效'
            });
          }
        }
      });
    } else {
      if (_callback) {
        _callback(err);
      } else {
        miloAlert({
          message: '您尚未登录或登录态已失效'
        });
      }
    }
  };
};
export var setLoginManager = function setLoginManager(instance) {
  GlobalManager.loginManager = instance;
};